import Title from "../Title";
import {useRouter} from "next/router";
import localized from "../../locale/locales";

export default function SectionJobsUs() {
    const {locale} = useRouter();
    const {sections: {jobsUs: lang}} = localized[locale];

    return (
        <section className="flex-1 flex flex-col gap-5 accent-orange-800">
            <header>
                <Title size="small">
                    {lang.title.localize({emoji: '✍️'})}
                </Title>
            </header>
            <ul className="max-w-[30ch] flex flex-col gap-5 list-disc ml-4 leading-[1.8] italic-accent-color">
                {lang.list.map((item, key) => {
                        return (
                            <li key={`Perks: ${key}`}
                                dangerouslySetInnerHTML={{__html: item.localize()}}/>
                        )
                    }
                )}

            </ul>
        </section>
    )
}